import { type CarrierDef } from '../common.js'
import { password, username, userPassMap } from '../internal.js'

const credentialTypes = [username, password] as const
const locationCredentialTypes = ['customer-code'] as const

export type abflCredType =
  | (typeof credentialTypes)[number]
  | (typeof locationCredentialTypes)[number]
export const abfl: CarrierDef<abflCredType> = {
  name: 'A&B Freight Line',
  scac: 'abfl',
  credentialTypes,
  locationCredentialTypes,
  legacyCredMap: [...userPassMap, ['customer-code', 'ref1']],
  engineLayers: ['rating'],
  credentialConfig: {
    'customer-code': { customerIdentifier: true },
  },
}
